const HEADING_PATTERNS = [
  /^about (the )?(role|job|position|opportunity)$/i,
  /^what (you'?ll|you will) do$/i,
  /^what we'?re looking for$/i,
  /^what you bring$/i,
  /^who you are$/i,
  /^your (profile|mission|impact|background)$/i,
  /^responsibilities$/i,
  /^key responsibilities$/i,
  /^requirements$/i,
  /^qualifications$/i,
  /^required (skills|qualifications|experience)$/i,
  /^preferred (skills|qualifications|experience)$/i,
  /^benefits( and perks)?$/i,
  /^what we offer$/i,
  /^why (join|work with) us$/i,
  /^application process$/i,
  /^next steps$/i,
];

const cleanLine = (line) => line.replace(/^[-*•▪◦]\s+/, "").trim();

const normalized = (value) => cleanLine(value).replace(/:$/, "").toLowerCase();

const isHeading = (line) => {
  const value = cleanLine(line);
  const plain = value.replace(/:$/, "");

  if (!plain || /^[-*•▪◦]\s+/.test(line)) {
    return false;
  }

  if (HEADING_PATTERNS.some((pattern) => pattern.test(plain))) {
    return true;
  }

  return value.endsWith(":") && plain.split(/\s+/).length <= 7 && plain.length <= 64;
};

const buildGroups = (lines) => {
  const groups = [];
  let group = [];

  lines.forEach((line) => {
    if (!line.trim()) {
      if (group.length) {
        groups.push(group);
        group = [];
      }
      return;
    }

    group.push({
      explicitBullet: /^[-*•▪◦]\s+/.test(line),
      text: cleanLine(line),
    });
  });

  if (group.length) {
    groups.push(group);
  }

  return groups;
};

const buildSections = (content) => {
  const sections = [];
  let active = { heading: "", lines: [] };

  content.replace(/\r/g, "").split("\n").forEach((line) => {
    if (isHeading(line)) {
      if (active.heading || active.lines.some((item) => item.trim())) {
        sections.push(active);
      }
      active = { heading: cleanLine(line).replace(/:$/, ""), lines: [] };
      return;
    }
    active.lines.push(line);
  });

  if (active.heading || active.lines.some((item) => item.trim())) {
    sections.push(active);
  }

  return sections;
};

export function JobDetailContent({ content, sectionTitle }) {
  if (!content?.trim()) {
    return null;
  }

  const sectionName = normalized(sectionTitle || "");
  const sections = buildSections(content);

  return (
    <div className="space-y-5 text-ink">
      {sections.map((section, sectionIndex) => {
        const showHeading = section.heading && normalized(section.heading) !== sectionName;
        const groups = buildGroups(section.lines);

        return (
          <div key={`${section.heading}-${sectionIndex}`}>
            {showHeading && (
              <h3 className="text-lg font-bold text-navy">{section.heading}</h3>
            )}
            <div className={showHeading ? "mt-3 space-y-3" : "space-y-3"}>
              {groups.map((group, groupIndex) => {
                const asPointers = group.length > 1 && (
                  Boolean(section.heading) || group.every((item) => item.explicitBullet)
                );

                if (asPointers) {
                  return (
                    <ul
                      key={groupIndex}
                      className="list-disc space-y-2 pl-5 marker:text-blue"
                    >
                      {group.map((item, itemIndex) => (
                        <li key={itemIndex}>{item.text}</li>
                      ))}
                    </ul>
                  );
                }

                return (
                  <p key={groupIndex}>
                    {group.map((item) => item.text).join(" ")}
                  </p>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}